export default {
  'menu.CRM': 'CRM',
  // Lead menu items
  'menu.CRM.leads': 'Leads',
  'menu.CRM.activities': 'Tasks',
  'menu.CRM.deals': 'Opportunities',
  'menu.CRM.contacts': 'Contacts',
  'menu.leads': 'Leads',
  'menu.deals': 'Opportunities',

  // Lead tabs
  'crm.tab.info': 'Info',
  'crm.tab.status': 'Status',
  'crm.tab.documents': 'Documents',
  'crm.tab.quotation': 'Quotation',
  'crm.tab.activities': 'Tasks',
  'crm.tab.memos': 'Memos',
  'crm.tab.emails': 'Emails',
  'crm.tab.deals': 'Deals',
  'crm.tab.opportunities': 'Opportunities',

  // Lead status
  'lead.status.title': 'Status Information',
  'lead.status.current': 'Current Status',

  // lead actions
  'lead.action.convert_to_contact': 'Convert to Contact',
  'lead.action.share': 'Share',

  // Lead actions
  'lead.update.success': 'Successfully updated lead',
  'lead.delete.success': 'Successfully deleted lead',
  'lead.disable.success': 'Successfully disabled lead',
  'lead.enable.success': 'Successfully enabled lead',
  'lead.delete.confirm': 'Are you sure you want to delete this lead?',
  'lead.disable.confirm': 'Are you sure you want to disable this lead?',
  'lead.enable.confirm': 'Are you sure you want to enable this lead?',

  // Lead fields
  'lead.field.name': 'Name',
  'lead.field.short_name': 'Short Name',
  'lead.field.local_name': 'Print Name',
  'lead.field.native_name': 'Local Reg. Name',
  'lead.field.type': 'Type',
  'lead.field.status': 'Status',
  'lead.field.potential_value': 'Potential Value',
  'lead.field.source': 'Source',
  'lead.field.emails': 'Email(s)',
  'lead.field.contact': 'Contact',
  'lead.field.phone': 'Phone',
  'lead.field.phone_ext': 'Phone Ext.',
  'lead.field.fax': 'Fax',
  'lead.field.mobile': 'Mobile',
  'lead.field.address': 'Address',
  'lead.field.city': 'City',
  'lead.field.state': 'State',
  'lead.field.country': 'Country',
  'lead.field.zip': 'Zip Code',
  'lead.field.notes': 'Notes',
  'lead.field.tags': 'Tags',
  'lead.field.title': 'Title',
  'lead.field.owner': 'Owner',
  // Lead status options
  'lead.status.new': 'New',
  'lead.status.qualified': 'Qualified',
  'lead.status.proposition': 'Proposition',
  'lead.status.negotiation': 'Negotiation',
  'lead.status.won': 'Won',
  'lead.status.lost': 'Lost',

  // Lead documents
  'lead.document.field.name_document_no': 'Name/Document No.',
  'lead.document.field.type': 'Type',
  'lead.document.field.description': 'Description',
  'lead.document.field.updated_at': 'Updated At',
  'lead.document.field.created_by': 'Created By',
  'lead.document.field.file': 'File',
  'lead.document.field.file.title': 'Click or drag file to this area to upload',
  'lead.document.field.notice': 'only members from your team can see it',
  'lead.document.field.name_document_no.placeholder': 'Enter name/document no.',
  'lead.document.field.name_document_no.required': 'Please enter name/document no.',
  'lead.document.field.type.required': 'Please select document type.',
  'lead.document.field.type.placeholder': 'Select document type',
  'lead.document.delete.success': 'Successfully Deleted Document',
  'lead.document.update.success': 'Successfully Updated Document',
  'lead.document.empty': 'No Documents',

  // Lead memos
  'lead.memo.add': 'Add Memo',
  'lead.memo.edit': 'Edit Memo',
  'lead.memo.delete': 'Delete Memo',
  'lead.memo.add.success': 'Successfully added Memo',
  'lead.memo.delete.success': 'Successfully deleted Memo',
  'lead.memo.delete.confirm': 'Are you sure to delete this memo?',
  'lead.memo.empty': 'No Memo',
  'lead.memo.title': 'Memos',
  'lead.memo.field.subject': 'Subject',
  'lead.memo.field.content': 'Content',
  'lead.memo.field.created_by': 'Created By',
  'lead.memo.field.created_at': 'Created At',
  'lead.memo.field.updated_at': 'Updated At',

  // Lead emails
  'lead.emails.title': 'Emails',
  'lead.emails.empty': 'No Emails',
  'lead.email.field.from': 'From',
  'lead.email.field.to': 'To',
  'lead.email.field.subject': 'Subject',
  'lead.email.field.message': 'Message',
  'lead.email.field.created_at': 'Created At',
  'lead.email.field.attachments': 'Attachments',

  // Lead activities
  'lead.activities.title': 'Tasks',
  'lead.activities.empty': 'No Tasks',
  'lead.activity.add': 'Add Task',
  'lead.activity.add.title': 'Add Task',
  'lead.activity.edit.title': 'Edit Task',
  'lead.activity.add.success': 'Successfully added task',
  'lead.activity.field.title': 'Title',
  'lead.activity.field.title.required': 'Please enter task title',
  'lead.activity.field.title.placeholder': 'Enter task title',
  'lead.activity.field.type': 'Type',
  'lead.activity.field.type.required': 'Please select task type',
  'lead.activity.field.type.placeholder': 'Select task type',
  'lead.activity.field.description': 'Description',
  'lead.activity.field.description.placeholder': 'Enter task detailed description',
  'lead.activity.field.status': 'Status',
  'lead.activity.field.status.required': 'Please select task status',
  'lead.activity.field.status.placeholder': 'Select task status',
  'lead.activity.field.due_date': 'Due Date',
  'lead.activity.field.due_date.required': 'Please select due date',
  'lead.activity.field.due_date.placeholder': 'Select due date and time',
  'lead.activity.field.is_recurring': 'Recurring',
  'lead.activity.field.recurring_every': 'Recurring Every',

  // Activity types
  'lead.activity.type.phone': 'Phone',
  'lead.activity.type.meeting': 'Meeting',
  'lead.activity.type.email': 'Email',
  'lead.activity.type.task': 'Task',
  'lead.activity.type.note': 'Note',

  // Activity status
  'lead.activity.status.planned': 'Planned',
  'lead.activity.status.completed': 'Completed',
  'lead.activity.status.cancelled': 'Cancelled',

  // Activity priority
  'crm.activity.list_title': 'Tasks',
  'crm.activity.field.subject': 'Subject',
  'crm.activity.field.owner': 'Task Owner',
  'crm.activity.field.type': 'Type',
  'crm.activity.field.priority': 'Priority',
  'crm.activity.field.contact': 'Contact',
  'crm.activity.field.start_time': 'Start Time',
  'crm.activity.field.end_time': 'End Time',
  'crm.activity.field.due_date': 'Due Date',
  'crm.activity.field.create_date': 'Created At',

  // deal fields
  'crm.deal.list_title': 'Opportunities',
  'crm.deal.field.name': 'Name',
  'crm.deal.field.owner': 'Owner',
  'crm.deal.field.contact': 'Contact',
  'crm.deal.field.amount': 'Amount',
  'crm.deal.field.stage': 'Stage',
  'crm.deal.field.code': 'Code',
  'crm.deal.field.status': 'Status',
  'crm.deal.field.account_name': 'Account Name',
  'crm.deal.field.contact_name': 'Contact Name',
  'crm.deal.field.closing_date': 'Closing Date',
  'crm.deal.field.probability': 'Probability',
  'crm.deal.field.expected_revenue': 'Expected Revenue',
  'crm.section.memo': 'Memo',
  'crm.section.basic_info': 'Basic Information',
  'crm.section.quotation': 'Quotations',
  'crm.deal.field.created_at': 'Created At',
  'crm.deal.field.updated_at': 'Updated At',
  'crm.deal.empty': 'No data found',
  'crm.section.proposal': 'Proposals',

  'deal.delete.confirm': 'Are you sure you want to delete this deal?',
  'deal.status.confirm': 'Change status to {status}?',

  'deal.status.qualification': 'Qualification',
  'deal.status.analysis': 'Need Analysis',
  'deal.status.proposition': 'Value Proposition',
  'deal.status.identification': 'Identify Decision Maker',
  'deal.status.developing': 'Developing',
  'deal.status.proposal': 'Proposal Review',
  'deal.status.negotiation': 'Negotiation/Review',
  'deal.status.won': 'Closed Won',
  'deal.status.lost': 'Closed Lost',
  'deal.status.lost_by_competitor': 'Closed Lost to Competitor',
  'deal.status.deferred': 'Deferred',
  'deal.remove_quotation.confirm': 'Are you sure you want to remove these quotations?',

  'proposal.create': 'Create Proposal',
};
